var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"360px","height":"220px"},attrs:{"id":"system-early-warning"}})}
var staticRenderFns = []

export { render, staticRenderFns }